<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="airports.icon" class="mr-1"></i>
                        <span>{{ airports.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">


                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="name" :debounce="airports.debounce"
                                            placeholder="Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!name"
                                                @click="name = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Type" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="type" :debounce="airports.debounce"
                                            placeholder="Type"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!type"
                                                @click="type = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Country Code" label-size="sm">

                                    <b-input-group>
                                        <b-form-input v-model="iso_country" :debounce="airports.debounce"
                                            placeholder="Country Code"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!iso_country"
                                                @click="type = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="IATA ( Paste List )" label-for="iata_code" label-cols="12">
                                    <b-input-group class="treeselect_all justify-content-end pr-2px">
                                        <b-form-checkbox-group id="isiata" v-model="isiata" :options="options_isiata"
                                            size="sm" value-field="id" text-field="label" name="radio-options"
                                            class="z-0" style="padding-top: 0.2em">
                                        </b-form-checkbox-group>
                                    </b-input-group>
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="iata_code" v-model="iata_code" tag-variant="primary"
                                            separator=" ,;" placeholder="Paste IATA (LGW,MAN,...)" size="sm"
                                            class="h-29" add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="iata_code = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="ID_ ( Paste List )" label-for="id_" label-cols="12">
                                    <b-input-group class="z-0">
                                        <b-form-tags input-id="id" v-model="id_" tag-variant="primary" separator=" ,;"
                                            placeholder="Paste ID_ (8719,8720,...)" size="sm" class="h-29"
                                            add-button-text="+" add-on-change remove-on-delete
                                            add-button-variant="outline-primary"></b-form-tags>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" @click="id_ = null">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>


                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="airports" :icon="airports.icon"
                        :busy="airports.busy" :toolbarlibrary="airports.toolbarlibrary" :tools="airports.tools"
                        :badges="airports.badges" :fields="airports.fields" :items="airports.items"
                        :limit="airports.limit" :downloaded="airports.downloaded" :showpages="true" :offset="airports.offset" :page="airports.page"
                        @load="airports_load" @click="airports_click" @changed="airports_click('save', $event)"
                        @select="airports_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="airports.selected" :config="cconfig"
                    @discard="airports_click('discard')" @go="airports_click('go')"></component>
            </div>
            <b-card-footer class="mt-2 ml-1">
                <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>     
            </b-card-footer>

        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import AirportEdit from "./Components/Setup_AirportEdit";

export default {
    name: "Airports",
    components: { AirportEdit },
    watch: {

        async name() {
            await this.airports_load(0);
        },
        async type() {
            await this.airports_load(0);
        },
        async iso_country() {
            await this.airports_load(0);
        },
        async iata_code() {
            await this.airports_load(0);
        },
        async isiata() {
            await this.airports_load(0);
        },
        async id_() {
            await this.airports_load(0);
        },
    },
    data() {
        return {
            name: null,
            type: null,
            iso_country: null,
            iata_code: [],
            id_: [],
            options_isiata: [
                { id: '1', label: 'Yes' },
                { id: '0', label: 'No' },

            ],
            isiata: "1",
            airports: {
                title: "Airports",
                icon: "fa fa-list",
                debounce: 500,
                busy: false,
                import: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,update,download,clipboard,add,edit,deleteconfirm",
                toolbarlibrary: [],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "name",
                        label: "Name",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "iso_country",
                        label: "Country",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "iata_code",
                        label: "IATA",
                        sortable: true,
                        class: "uppercase"
                    },
                    {
                        key: "latitude_deg",
                        label: "Lattitude",
                        sortable: true,
                        class: "text-right"
                    },
                    {
                        key: "longitude_deg",
                        label: "Longitude",
                        sortable: true,
                        class: "text-right"
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.airports_load(0);
    },

    methods: {
        accessdenied() {
            this.airports.denied = [];
            if (!this.user.permissions.includes("setup_airports.admin")) {
                this.airports.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("setup_airports.admin")) {
                this.airports.denied.push("add");
                this.airports.denied.push("save");
            }

        },

        async airports_load(offset, limit, page) {
            let state = this.airports;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                name: this.name,
                type: this.type,
                iso_country: this.iso_country,
                iata_code: this.iata_code.length > 0 ? this.iata_code.join(",") : null,
                isiata: this.isiata ? this.isiata == "1" ? true : false : null,
                id_: this.id_.length > 0 ? this.id_.join(",") : null,
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
              query setup_airports(
                $limit: Int
                $offset: Int
                $name: String            
                $type: String  
                $iso_country: String            
                $iata_code: String  
                $id_: String    
                $isiata: Boolean         
              ) {
                setup_airports(
                  limit: $limit
                  offset: $offset
                  name: $name 
                  type: $type
                  iso_country: $iso_country 
                  iata_code: $iata_code
                  isiata: $isiata
                  id_: $id_
                ) {
                  id
                  type                 
                  name
                  iso_country
                  iata_code
                  latitude_deg
                  longitude_deg    
                  updated_at
                  updated_by            
                  rows
                }
              }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE
               
                state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_airports
        } else {
          state.items = response.data.setup_airports;
        }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async airports_click(a, ss) {

            let state = this.airports;

            switch (a) {
                case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.airports_load(0, 0);
          break;
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.airports_load(0);
                    break;
                case "go":
                    this.component = null;
                    await this.airports_load(0);
                    break;
                case "add":
                case "edit":
                    this.component = "AirportEdit";
                    break;
                case "save":
                    this.saveit(ss);
                    break;
                case "update":
                    await this.updateit(ss)
                    break;
                case "delete":
                    await this.deleteit(ss);
                    break;
            }
        },
        async airports_select(ss, tools) {

            let state = this.airports;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "update", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async saveit(ss) {
            // let requirement = { ...this.requirement_bookerinitial };


            // let requirements = "";
            // for (var prop in requirement) {
            //   if (this.item[prop] == null) {
            //     requirements += requirement[prop] + ", ";
            //     // break;
            //   }
            // }
            // if (requirements.length > 0) {
            //   this.message =
            //     "<span class='text-danger'>" +
            //     requirements.slice(0, -1) +
            //     " required field(s). </span>";
            //   return;
            // }
            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_airports_save(
                $rows: [setup_airports_input]             
              ) {
                setup_airports_save(rows: $rows) {
                    id
                    ident
                    name
                    type          
                    latitude_deg
                    longitude_deg
                    elevation_ft
                    continent
                    iso_country
                    iso_region
                    municipality
                    scheduled_service
                    gps_code
                    iata_code   
                    local_code
                    home_link
                    wikipedia_link
                    keywords        
                }
              }
            `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_airports_delete(
                $rows: [setup_airports_input]
              ) {
                setup_airports_delete(rows: $rows) {
                  id
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.airports_load(0);
        },
        async updateit(ss) {

            if (await this.$bvModal.msgBoxConfirm('Data is refreshed from https://ourairports.com/help/data-dictionary.html#airports.', {
                title: 'Please confirm you want to refresh the airports code file?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                this.airports.busy = true

                let variables = {
                    rows: [],
                    apply: true
                };

                try {
                    const response = await this.$apollo.mutate({
                        mutation: gql`
                            mutation setup_airports_import($rows: [FilePreview_input], $apply: Boolean) {
                                setup_airports_import(rows: $rows, apply: $apply) {
                                    sheet
                                    fields
                                    items
                                    type
                                }
                            }
              `,
                        variables,
                    });
                    this.message = "<span class='text-primary'>Imported it.</span>";

                    // this.sheets = response.data.bankingslines_import


                } catch (error) {
                    this.message = "<span class='text-danger'>" + error.message + "</span>";
                }

                this.airports.busy = false

            } else {
                this.airports.busy = false
            }

        }
    },
};
</script>

<style></style>